// Display names for subscription plans (T0 / D5, ENG2-2452). The 2026
// packages get the names Sales uses; legacy plans keep their raw name.
const PLAN_LABELS: Record<string, string> = {
  TRIAL_V2: 'TrialV2',
  TRIAL_MCP: 'Trial-MCP',
  MANUAL_PACKAGE: 'Manual Package',
  STRATEGIC_PACKAGE: 'Strategic Package',
}

export const planLabel = (plan: string | undefined | null): string =>
  plan ? PLAN_LABELS[plan] ?? plan : ''
